import React from "react"

import Grid from "@material-ui/core/Grid"
import Card from "components/index/Card"
import "./result-related-break.scss"

const ResultRelatedBreak = ({ relatedBreaks }) => {
 
 

  return (
    <>
   {relatedBreaks && relatedBreaks.length > 0 && (
    <Grid container justify="center" spacing={2}>
      <Grid item xs={12} md={9}>
        <div className={`result-related-break`}>
          <h3 className={`headline`}>Up Next</h3>
          <Card brk={relatedBreaks[0]} />
        </div>
      </Grid>
    </Grid>
   )}
   </>
  )
}
export default ResultRelatedBreak
